export const FETCH_ITEM_LOCATION_LISTING = "FETCH_ITEM_LOCATION_LISTING";
export const FETCH_ITEM_LOCATION_LISTING_SUCCESS = "FETCH_ITEM_LOCATION_LISTING_SUCCESS";
export const FETCH_ITEM_LOCATION_LISTING_FAILURE = "FETCH_ITEM_LOCATION_LISTING_FAILURE";
export const RESET = 'RESET';
